import * as React from "react";
import { SimpleEditor } from "./Editor/SimpleEditor";
export class TextBox extends React.Component {
    constructor(props) {
        super(props);
        this.updateContent = (newContent) => {
            if (this.props.onChange !== undefined) {
                const onChange = this.props.onChange;
                onChange(newContent);
            }
        };
    }
    render() {
        const { className } = this.props;
        return (React.createElement("div", { className: className },
            React.createElement(SimpleEditor, { content: this.props.text, editable: this.props.editable, onChange: this.updateContent, forceReset: this.props.forceReset })));
    }
}
//# sourceMappingURL=TextBox.js.map